import * as React from 'react';
import { Price, Loader, Alert } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl, useDispatch, useSelector } from '@grandvisionhq/state';
import { isNil } from '@grandvisionhq/utils';
import { selectShippingMethod } from '../../../actions.js';
import { getSelectedShippingMethod } from '../../../selectors.js';
import { useShippingMethodSelection } from '../hooks/use-shipping-method-selection.js';
import { useShippingMethodsList } from '../hooks/use-shipping-methods-list.js';
import { mapShippingMethods } from '../../../../mappers/view/shipping-methods.js';
import { ShippingMethodsList } from '../components/ShippingMethodsList.js';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';

const ShippingMethodsListContainer = ({ asides , onChange  })=>{
    const { getLabel , locale , currency  } = useIntl();
    const dispatch = useDispatch();
    const { shipping , shippingMethodsLogos  } = useCheckoutSettings();
    const labels = React.useMemo(()=>({
            errorTitle: getLabel('checkout.errors.general.title'),
            errorMessage: getLabel('checkout.errors.general.message'),
            free: getLabel('common.free'),
            required: getLabel('common.form.field.requiredError')
        })
    , [
        getLabel
    ]);
    const shippingMethodInfo = React.useCallback(({ price , logo , isFree  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, logo, !isFree && !isNil(price) && /*#__PURE__*/ React.createElement(Price, {
            value: price,
            centAmount: true,
            currency: currency,
            className: "checkout-shipping-methods__price"
        }), isFree && /*#__PURE__*/ React.createElement(Text, {
            className: "checkout-shipping-methods__label"
        }, labels.free))
    , [
        currency,
        labels
    ]);
    const { shippingMethodList , reloadShippingMethods , isLoading , error  } = useShippingMethodsList();
    const onError = React.useCallback(()=>{
        reloadShippingMethods();
    }, [
        reloadShippingMethods
    ]);
    const { handleOnShippingMethodSelected  } = useShippingMethodSelection({
        shippingMethodList,
        onError
    });
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const items = mapShippingMethods({
        asides,
        logos: shippingMethodsLogos,
        locale,
        shippingMethodList,
        shippingMethodInfo
    });
    // If settings require explicit shipping method selection, invalidate and deselect shipping method on load
    React.useEffect(()=>{
        if (!(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod)) {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: false
                }
            }));
        }
    }, [
        dispatch,
        selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched,
        selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid,
        shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod, 
    ]);
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (error) {
        return /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            title: labels.errorTitle,
            message: labels.errorMessage
        });
    }
    const hasValidationError = !(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isValid) && (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.isTouched);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ShippingMethodsList, {
        handleChange: (method)=>{
            onChange === null || onChange === void 0 ? void 0 : onChange();
            handleOnShippingMethodSelected(method);
        },
        shippingMethodItems: items,
        selectedShippingMethod: (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) ? selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method : '',
        hasValidationError: hasValidationError
    }), hasValidationError && /*#__PURE__*/ React.createElement(Text, {
        className: "form-control__error"
    }, labels.required));
};

export { ShippingMethodsListContainer };
//# sourceMappingURL=ShippingMethodsListContainer.js.map
